import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

export const UseCaseHero = () => {
  const scrollToContent = () => {
    document.getElementById('use-case-intro')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-[70vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background gradient with parallax effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-teal via-midnight-green to-deep-teal">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&q=80')] bg-cover bg-center opacity-20 mix-blend-overlay"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-deep-teal/90 via-deep-teal/50 to-transparent"></div>
      </div>

      {/* Animated accent elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-10 w-32 h-32 bg-copper rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-20 w-40 h-40 bg-copper/60 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-ivory mb-6 animate-fade-in">
          Every Camp Kitchen <br />
          <span className="text-copper">Has Its Story</span>
        </h1>
        <p className="text-xl md:text-2xl text-ivory/90 mb-10 max-w-3xl mx-auto leading-relaxed animate-fade-in" style={{ animationDelay: '0.2s' }}>
          From summer camps to faith-based retreats, CampChef Pro powers meal planning, Sysco ordering, and kitchen coordination across the country.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <Button 
            asChild 
            size="lg"
            className="min-w-[200px] bg-copper hover:bg-copper/90 text-deep-teal font-semibold shadow-xl hover:shadow-2xl hover:scale-105 transition-all"
          >
            <Link to="/contact">Request a Camp Demo</Link>
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={scrollToContent}
            className="min-w-[200px] border-2 border-ivory text-ivory bg-ivory/20 hover:bg-ivory/30 hover:border-ivory transition-all"
          >
            Learn More
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button 
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-ivory/70 hover:text-ivory transition-colors animate-bounce"
        aria-label="Scroll to content"
      >
        <ChevronDown className="h-8 w-8" />
      </button>
    </section>
  );
};
